import { ARGYLE_VERBOSE_LOGGING } from "../../config";

export const ARGYLE_VERBOSE_LOGGING_ENABLED = ARGYLE_VERBOSE_LOGGING;

export const argyleVerboseLog = (stage: string, payload?: unknown) => {
  if (!ARGYLE_VERBOSE_LOGGING_ENABLED) return;
  // Centralized wrapper so future payload shaping can happen in one place.
  // eslint-disable-next-line no-console
  console.info(`[ArgyleVerbose] ${stage}`, payload ?? {});
};
